// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1PasswordUpdateSchema = z.object({
  user: z.object({
    password: z.coerce.string().min(8).describe("New password (minimum 8 characters)"),
    password_confirmation: z.coerce.string().min(1).describe("Password confirmation (must match password)"),
    current_password: z.coerce.string().min(1).describe("Current password for verification"),
  }),
});
